export default [
  {
    path: '/app/tasks',
    name: 'Tasks',
    component: () => import('@/views/Tasks/Index.vue'),
    meta: {
      navActiveLink: 'Tasks',
      pageTitle: 'nav.tasks',
      breadcrumb: [{ text: 'breadcrumb.list', active: true }],
      resource: 'TASKS_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/tasks/add',
    name: 'TasksAdd',
    component: () => import('@/views/Tasks/Add.vue'),
    meta: {
      navActiveLink: 'Tasks',
      pageTitle: 'nav.tasks',
      breadcrumb: [
        { text: 'breadcrumb.list', to: '/app/tasks', active: false },
        { text: 'breadcrumb.create', active: true },
      ],
      resource: 'TASKS_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/tasks/detail/:id',
    name: 'TasksDetail',
    component: () => import('@/views/Tasks/Detail.vue'),
    meta: {
      navActiveLink: 'Tasks',
      pageTitle: 'pages.taskDetail',
      breadcrumb: [
        { text: 'breadcrumb.list', to: '/app/tasks', active: false },
        { text: 'breadcrumb.detail', active: true },
      ],
      // Atanan kullanıcı da açabilmeli; hangi kaydı göreceğine BE görünürlüğü karar verir.
      resource: 'APP_DASHBOARD',
      action: 'read',
    },
  },
  {
    path: '/app/my-subtasks',
    name: 'MySubtasks',
    component: () => import('@/views/MySubtasks/Index.vue'),
    meta: {
      navActiveLink: 'MySubtasks',
      pageTitle: 'nav.mySubtasks',
      breadcrumb: [{ text: 'breadcrumb.list', active: true }],
      resource: 'APP_DASHBOARD',
      action: 'read',
    },
  },
  {
    path: '/app/tasks/edit/:id',
    name: 'TasksEdit',
    component: () => import('@/views/Tasks/Edit.vue'),
    meta: {
      navActiveLink: 'Tasks',
      pageTitle: 'nav.tasks',
      breadcrumb: [
        { text: 'breadcrumb.list', to: '/app/tasks', active: false },
        { text: 'breadcrumb.update', active: true },
      ],
      resource: 'TASKS_EDIT',
      action: 'read',
    },
  },
]
